import { createTheme } from '@material-ui/core/styles';
import responsiveFontSizes from '@material-ui/core/styles/responsiveFontSizes';
import overrides from './overrides/index';
import palette from './palette';
import typography from './typography';

let theme = createTheme({
  overrides,
  palette,
  typography,
});

export default responsiveFontSizes(theme);
